module.exports = __webpack_public_path__ + "static/media/img12.61565734.jpg";